module.exports = __webpack_public_path__ + "static/media/CI.9915d8cd.png";